import React from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { toggleOlxProPopup } from '../../core/actions';

const KnowMore = styled.a`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #9027b0;
  text-decoration: none;
  cursor: pointer;
`;

const OlxProKnowMore = ({ handleClick }) => (
  <KnowMore onClick={handleClick}>Saiba mais!</KnowMore>
);

OlxProKnowMore.propTypes = {
  handleClick: func.isRequired,
};

export default connect(null, { handleClick: toggleOlxProPopup })(OlxProKnowMore);
